import ANALYTICS from 'constants/analytics';

const { ACTION_OPEN_MODAL } = ANALYTICS;

/**
 * @name openModal
 * @desc Opens modal uniquely identified by "modalKey"
 * @param {String} modalKey - Unique key for the modal to be opened
 * @param {Object} [options] - Optional object with props to pass to the modal and optional Analytics properties and other
 * @returns {{type: string, modalKey: string, props?: Object}}
 * @memberof actions.modal
 * @example
 * dispatch(openModal('myUniqueModalKey')); // original usage
 * dispatch(openModal('myUniqueModalKey', { props: { someData: 'value' }})); // with props
 * dispatch(openModal('myUniqueModalKey', { props: { someData: 'value' }, analytics: true })); // with props and args

 */
export function openModal(modalKey, options = {}) {
  return {
    ...options,
    modalKey,
    type: ACTION_OPEN_MODAL,
  };
}
